// extracted by mini-css-extract-plugin
module.exports = {"row":"TableSkeleton_row__3wRcm","pulse":"TableSkeleton_pulse__3Ztuc"};